const TRUTHY_ENV_VALUES = new Set(["1", "true", "yes", "on"]);

export const readFeatureFlag = (value, defaultValue = false) => {
  if (typeof value !== "string") {
    return defaultValue;
  }

  return TRUTHY_ENV_VALUES.has(value.trim().toLowerCase());
};

export const featureFlags = Object.freeze({
  guidedResumeCreator: readFeatureFlag(process.env.REACT_APP_ENABLE_GUIDED_RESUME_CREATOR, false),
  savedResumes: readFeatureFlag(process.env.REACT_APP_ENABLE_SAVED_RESUMES, false),
  interviewPrep: readFeatureFlag(process.env.REACT_APP_ENABLE_INTERVIEW_PREP, false),
  jobSearchSuggestions: readFeatureFlag(process.env.REACT_APP_ENABLE_JOB_SEARCH_SUGGESTIONS, false),
});

export const isFeatureEnabled = (featureName) =>
  Object.prototype.hasOwnProperty.call(featureFlags, featureName)
    ? featureFlags[featureName]
    : false;
